import * as z from "zod";

import { additionalDataSchema } from "./additional-field";
import {
  apartmentSchema,
  getApartmentSchemaWithAdditionalFields,
} from "./apartment";
import { getHoldingSchemaAdditionalFields, holdingSchema } from "./holding";
import { getSubletSchemaAdditionalFields, subletSchema } from "./sublet";

export const holdingWithApartmentAndSubletsSchema = holdingSchema.extend({
  apartment: apartmentSchema,
  sublets: z.array(subletSchema),
  issueCount: z.number().int().nonnegative().default(0),
});

export type HoldingWithApartmentAndSublets = z.infer<
  typeof holdingWithApartmentAndSubletsSchema
>;

export function getHoldingWithApartmentAndSubletsSchemaWithAdditionalFields(additionalFields: {
  holding: typeof additionalDataSchema;
  sublet: typeof additionalDataSchema;
  person: typeof additionalDataSchema;
  organization: typeof additionalDataSchema;
  apartment: typeof additionalDataSchema;
}): typeof holdingWithApartmentAndSubletsSchema {
  return getHoldingSchemaAdditionalFields(additionalFields).extend({
    apartment: getApartmentSchemaWithAdditionalFields(additionalFields),
    sublets: z.array(getSubletSchemaAdditionalFields(additionalFields)),
    issueCount: z.number().int().nonnegative().default(0),
  });
}
